export default __webpack_public_path__ + "static/media/modal06.58ac2321.png";